/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Zugconfiguration1Inputs */

const de__field_zugconfiguration1 = /** @type {(inputs: _Field_Zugconfiguration1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zug-Konfiguration`)
};

/**

* @param {_Field_Zugconfiguration1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_zugconfiguration1 = /** @type {((inputs?: _Field_Zugconfiguration1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Zugconfiguration1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_zugconfiguration1(inputs)
});
export { _field_zugconfiguration1 as "_field_zugConfiguration" }